import React from "react";
import { VaccineTypeRegisterForm } from "../../../components/VaxYes";
import { IntroText, FormActionDrawer } from "../../../components";
import { useTranslation } from "react-i18next";

const VaxYesRegisterStepVaccineType = ({
  setDrawerClearance,
  onNext = () => {},
  registerData = {}
}) => {
  const { t } = useTranslation();

  return (
    <>
      <IntroText>
        {t("vax_yes.vax_yes_register_vaccine_type.intro_text")}
      </IntroText>
      <VaccineTypeRegisterForm
        initialValues={registerData}
        onSubmitSuccess={onNext}
      >
        <FormActionDrawer
          setDrawerClearance={setDrawerClearance}
          nextButtonLabel={t(
            "vax_yes.vax_yes_register_vaccine_type.button_next"
          )}
        />
      </VaccineTypeRegisterForm>
    </>
  );
};

export { VaxYesRegisterStepVaccineType };
